import $ from "jquery";

const MIN_ZOOM = 0;
const MAX_ZOOM = 2; //200%

//Zoom CSS wasn't available since chrome update version in August 2024

function getZoomValue() {

    /**/if (navigator.userAgent.indexOf("Firefox") !== -1) {
      var values = $('#editor').css("transform").replace("matrix(", "").replace(")", "").split(',');
      var a = parseFloat(values[0]);
      var b = parseFloat(values[1]);
      return Math.sqrt(a * a + b * b);
    }
    else {
      /**/var values = $('#editor').css("transform").replace("matrix(", "").replace(")", "").split(',');
      var a = parseFloat(values[0]);
      var b = parseFloat(values[1]);
      return Math.sqrt(a * a + b * b);
      //return parseFloat($('#editor').css("zoom"));

    }
  }

  function zoomEditor(context: any) {

    const { setZoomValue, selectedItem, objItems} = context;

    var zoomValue = getZoomValue() + .05;

    if (zoomValue < MAX_ZOOM) {
      if (navigator.userAgent.indexOf("Firefox") !== -1) $('#editor').css({ '-moz-transform': 'scale(' + zoomValue + ')' });
      else {
        $('#editor').css({ 'transform': 'scale(' + zoomValue + ')' });
      }
      setZoomValue(zoomValue);
    }

    //updateMoveCardSize (selectedItem, objItems, zoomValue)
  }

  function dezoomEditor(context: any) {

    const { setZoomValue, selectedItem, objItems } = context;

    var zoomValue = getZoomValue() - .05;
    //var zoomValueFireFox = +$('#editor').css("zoom") - .1;
    if (zoomValue > MIN_ZOOM) {
      if (navigator.userAgent.indexOf("Firefox") !== -1) $('#editor').css({ '-moz-transform': 'scale(' + zoomValue + ')' });
      else {
        $('#editor').css({ 'transform': 'scale(' + zoomValue + ')' });
      }
      setZoomValue(zoomValue);
    }

    //updateMoveCardSize (selectedItem, objItems, zoomValue)

  }

  function fitZoom(context: any) {

    const { setZoomValue, pageSize } = context;

    let editorContainter = $(".editor-container");

    if (editorContainter != undefined) {
      var widthC = editorContainter.width();
      var heightC = editorContainter.height();

      //object is to have things like 0.9, with round down == floor
      var fitValue = (Math.floor(Math.min(widthC! / pageSize.width, heightC! / pageSize.height) * 10) / 10) - 0.05;

      if (fitValue > MIN_ZOOM) {
        if (navigator.userAgent.indexOf("Firefox") !== -1) $('#editor').css({ '-moz-transform': 'scale(' + fitValue + ')' });
        else {
          $('#editor').css({ 'transform': 'scale(' + fitValue + ')' });
        }
        setZoomValue(fitValue);
      }

      //Finish with centering page
      centerPage();
    }

  }

  function centerPage() {
    let page = document.getElementById("page");
    if (page != null) {
      page.scrollIntoView({
        behavior: "auto",
        block: "center",
        inline: "center",
      });
    }
  }

  function updateMoveCardSize (selectedItem : any, objItems : any, zoomValue : any) {
    //si on a un item sélectionner, on et à jour la taille de la move card
    if(selectedItem != null) {
      console.log("maj")
      let item = objItems.find((item: { id: any; }) => item.id === selectedItem!.id);
      item.rndClone.current.updateSize({width : 100 / zoomValue, height : 100 / zoomValue})
    }
  }


export { getZoomValue, zoomEditor, dezoomEditor, fitZoom, centerPage };